import React from "react";
import "./Css/ExamView.css";
import { useNavigate } from "react-router-dom";


const ExamDetails = () => {
    const navigate = useNavigate();

     const handleEditClick = (index) => {
  navigate("/dashboard/examedit"); 
};
  return (
    <div className="exam-container">
      <div className="page-header">
        <h3    style={{ cursor: "pointer" }}
        onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन  &gt;&gt; <span>परीक्षा तपशील</span>
        </h3>
        <button className="edit-btn" onClick={() => handleEditClick()} >एडिट करा</button>
      </div>
<h2>परीक्षा तपशील</h2>
      {/* Form Section */}
      <div className="exam-form">
        <div className="form-group">
          <label>परीक्षेचे नाव</label>
          <input value="पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा" readOnly />
        </div>

        <div className="form-group">
          <label>परीक्षा प्रकार</label>
          <input value="परीक्षा प्रकार १" readOnly />
        </div>

        <div className="form-group">
          <label>इयत्ता</label>
          <input value="५ वी" readOnly />
        </div>

        <div className="form-group">
          <label>विषय</label>
          <input value="मराठी" readOnly />
        </div>

        <div className="form-group">
          <label>परीक्षेची तारीख</label>
          <input value="५ जानेवारी, २०२६" readOnly />
        </div>

        <div className="form-group">
          <label>कालावधी</label>
          <input value="९० मिनिटे" readOnly />
        </div>

        <div className="form-group">
          <label>एकूण गुण</label>
          <input value="२५" readOnly />
        </div>

        <div className="form-group">
          <label>परीक्षा स्थिती</label>
          <input value="चालू परीक्षा" className="status-active" readOnly />
        </div>
      </div>

    </div>
  );
};

export default ExamDetails;
